import React, { useState } from 'react';
import { Download, CheckCircle, X } from 'lucide-react';
import axios from 'axios';
import API_BASE_URL from '../config/api';

const LeadMagnetBox = ({ position = 'default' }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setError('Veuillez entrer une adresse email valide');
      return;
    }

    setLoading(true);
    setError('');

    // Sauvegarder la position actuelle du scroll
    const scrollPosition = window.scrollY;

    try {
      await axios.post(`${API_BASE_URL}/lead-magnet`, {
        email,
        guide: 'Guide 3ème Pilier 2025',
        position
      });
      setSuccess(true);
      setEmail('');
      
      // Restaurer la position du scroll après le changement d'état
      setTimeout(() => {
        window.scrollTo(0, scrollPosition);
      }, 0);
      
      setTimeout(() => setSuccess(false), 5000);
    } catch (err) {
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="glass p-8 rounded-2xl border border-green-500/50 shadow-xl mb-8 bg-gradient-to-br from-green-500/20 to-emerald-500/20 animate-pulse-slow">
        <div className="flex flex-col items-center justify-center gap-4 text-center">
          <CheckCircle className="w-16 h-16 text-green-400 animate-bounce" />
          <div>
            <h3 className="text-2xl font-bold mb-2 text-green-400">✅ C'est envoyé !</h3>
            <p className="text-gray-300 text-lg mb-2">
              Consultez votre boîte mail pour recevoir votre rapport personnalisé
            </p>
            <p className="text-gray-400 text-sm">
              (Pensez à vérifier vos spams si vous ne le voyez pas)
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="glass p-8 rounded-2xl border border-white/20 shadow-xl mb-8 bg-gradient-to-br from-green-500/10 to-emerald-500/10">
      <div className="flex items-start gap-4 mb-4">
        <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-3 rounded-xl">
          <Download className="w-8 h-8 text-white" />
        </div>
        <div className="flex-1">
          <h3 className="text-2xl font-bold mb-2 bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
            📧 Recevez le Guide Complet + 3 Stratégies Exclusives
          </h3>
          <p className="text-gray-300">
            Recevez immédiatement par email votre rapport personnalisé avec 3 stratégies d'optimisation fiscale que 95% des Neuchâtelois ignorent.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Votre adresse email"
            className="w-full px-4 py-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
            required
          />
        </div>
        
        {error && (
          <div className="flex items-center gap-2 text-red-400 text-sm">
            <X className="w-4 h-4" />
            <span>{error}</span>
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-emerald-700 transition-all transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {loading ? (
            'Envoi en cours...'
          ) : (
            <>
              <Download className="w-5 h-5" />
              Recevoir mon rapport par email
            </>
          )}
        </button>

        <p className="text-xs text-gray-400 text-center">
          Vos données sont protégées. Pas de spam, seulement du contenu de qualité.
        </p>
      </form>
    </div>
  );
};

export default LeadMagnetBox;